import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Loader from "react-loader-spinner";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";


class Spinner extends Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }

    render() {
        const { loader } = this.props;
        return (
            <>
                {loader ? <div className="loader-style">
                    <Loader style={{ justifyContent: 'center' }}
                        type="Bars"
                        color="#cf2264"
                        height={50}
                        width={50}
                    />
                </div>:<></>}
            </>
        )
    }


}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({}, dispatch);
}

function mapStateToProps({ loader }) {
    return { loader };
}
export default (connect(mapStateToProps, mapDispatchToProps)(Spinner));